import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("API Error:", error.response ? error.response.data : error.message);
        return Promise.reject(error);
    }
);

export const apiService = {
    // --- FORM ENDPOINTS ---
    fetchForms: async () => {
        const response = await apiClient.get('forms');
        return response.data.data;
    },

    fetchForm: async (id) => {
        const response = await apiClient.get(`forms/${id}`);
        return response.data.data;
    },

    createForm: async (formData) => {
        const response = await apiClient.put('forms', formData);
        return response.data.data;
    },

    updateForm: async (id, formData) => {
        const response = await apiClient.put(`forms/${id}`, formData);
        return response.data.data;
    },

    deleteForm: async (id) => {
        const response = await apiClient.delete(`forms/${id}`);
        return response.data;
    },

    // --- ENTRY ENDPOINTS ---
    fetchEntries: async (formId) => {
        const response = await apiClient.post('entries', {
            form: formId
        });
        return response.data.data;
    },

    createEntry: async (data) => {
        const response = await apiClient.put('entries', data);
        return response.data.data;
    },

    updateEntry: async (id, data) => {
        const response = await apiClient.put(`entries/${id}`, data);
        return response.data.data;
    },

    deleteEntry: async (id) => {
        const response = await apiClient.delete(`entries/${id}`);
        return response.data;
    },

    /**
     * UPDATED: Accepts extraData (like { updated_by: 'Name' }) 
     * to ensure the backend knows who is finalizing the drafts.
     */
    submitAllDrafts: async (formId, extraData = {}) => {
        const response = await apiClient.post('entries/submit-all', {
            form: formId,
            ...extraData // This will now send 'remarks' to the Python backend
        });
        return response.data;
    }
};